import { AxiosError, AxiosResponse } from "axios";
import { DataType, FieldType } from "@websential/cosmic-v20";
import {
	IChequeSettings,
	IChequeSettingsListPayload,
	IChequeSettingsResponse,
} from "../models/ChequeSettings";
import { IGetListRequest, IResponse, IServerError } from "../models/common";

import { GridSize } from "@mui/material";
import http from "../common/http-commons";

// import { IFixedAndMetaField } from 'common/FlexFieldsUtils';

// import { IVendorListPayload, IVendorRequest, IVendorResponse } from 'models/vendor';
// import { CLIENT_SETUP_FORM, CLIENT_SETUP_FORM_FOR_ADMIN_USER } from 'screensLayoutData/client';

// import { IAPIKeysRequest, IAPIKeysResponse } from '../models';

// import { IChequeSettingsListPayload, IChequeSettingsRequest, IChequeSettingsResponse } from '../models/chequeSettings';



// import { INITIAL_PAGE_SIZE } from 'common/constants';

export const ChequeSettingsService = {
	getChequeSettings: async (
		clientId: string,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void
	): Promise<
		| IChequeSettingsListPayload
		| IServerError
		| IResponse
		| IChequeSettingsResponse[]
	> => {
		try {
			const response: AxiosResponse<IChequeSettingsListPayload> =
				await http.get<IChequeSettingsListPayload>(
					"/v1/cheque-settings/?client_id=" +
						clientId +
						"&order_by=" +
						data.order_by +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size +
						"&search_query=" +
						data.search_query
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
			
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getByClientId: async (
		clientId: string,
		// id: string | undefined,
		navigateToLogout: (path: string) => void
	): Promise<IChequeSettings | IServerError | IResponse | null | any> => {
		if (!clientId) return null;
		try {
			const response: AxiosResponse<IChequeSettings> =
				await http.get<IChequeSettings>(
					`/v1/cheque-settings/${clientId}/`
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	create: async (
		requestPayload: any
	): Promise<IChequeSettings | IServerError | IResponse | any> => {
		if (requestPayload.id) {
		
			try {
				const response: AxiosResponse<IChequeSettings> =
					await http.put<IChequeSettings>(
						`/v1/cheque-settings/${requestPayload.id}/`,
						requestPayload
					);

				if (response.status === 200) {
					return response;
				} else if (response.status === 400) {
					return response.data;
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					requestPayload.navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
				
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}

	
		try {
			const response: AxiosResponse<IChequeSettings> =
				await http.post<IChequeSettings>(
					`/v1/cheque-settings/?client_id=${requestPayload.clientId}`,
					requestPayload
				);

		
			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delChequeSettings: async (
		delPayload: any
	): Promise<string | IServerError | IResponse | any> => {
	
		// return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
		try {
			const response: AxiosResponse<string> = await http.delete<string>(
				`/v1/cheque-settings/${delPayload.chequeSettingsId}/`
			);

			if (response.status === 204) {
				return "ChequeSettings has been deleted successfully";
			} else if (response.status === 200) {
				return "ChequeSettings has been deleted successfully";
			}  else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delBulkChequeSettingses: async (
		requestPayload: any
	): Promise<string | IServerError | IResponse> => {
		
		try {
			const response = await http.delete<string>(`/v1/cheque-settings/`, {
				data: requestPayload.chequeSettingsIds,
			});
			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
			
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getGetChequeSettingsDDL: async (
		clientId: string
	): Promise<any | IServerError | IResponse | null> => {
		const response: AxiosResponse<any[]> = await http.get<any[]>(
			`/v1/cheque-settings/chequeSetting-ddl?client_id=${clientId}`
		);

	

		if (response.status === 200) {
			return response.data;
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	archiveChequeSettings: async (
		archivePayload: any
	): Promise<string | IServerError | IResponse | any> => {
		
		// return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
		try {
			const response: AxiosResponse<string> = await http.post<string>(
				`/v1/cheque-settings/${archivePayload.chequeSettingsId}/`
			);

			if (response.status === 201) {
				return "ChequeSettings has been archived successfully";
			} else if (response.status === 200) {
				return "ChequeSettings has been archived successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				archivePayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
};
